<template>
  <div class="skeleton-screen" :class="theme">
    <div class="ss-item" :style="combinedStyle" :class="`ss-item-${index}`" v-for="(item, index) of rows" :key="index" />
  </div>
</template>

<script>
export default {
  name: 'SkeletonScreen',
  props: {
    barStyle: {
      type: String,
      default: 'full',
    },
    theme: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: 5,
    },
    customStyle: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  data() {
    return {
    }
  },
  computed: {
    combinedStyle() {
      if (this.barStyle === 'gradient') {
        return {
          height: '10px'
        }
      }
      const defaultStyle = {
        width: '100%',
        height: '10px'
      };
      
      if (Array.isArray(this.customStyle)) {
        return [defaultStyle, ...this.customStyle];
      }
      // 如果父组件传入的是对象形式的style
      return {
        ...defaultStyle,
        ...this.customStyle
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.skeleton-screen {
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex-shrink: 0;
  gap: 16px;

  .ss-item {
    animation: skeleton-loading 1.4s ease infinite;
    border-radius: 5px;
    background-image: linear-gradient(90deg,
        rgba(198, 206, 254, 0) 0%,
        rgba(195, 202, 249, 0.8) 50.5%,
        rgba(198, 206, 254, 0) 100%);
    background-size: 400% 100%;

    &-0 {
      width: 100%;
    }
  
    &-1 {
      width: 80%;
    }

    &-2 {
      width: 60%;
    }

    &-3 {
      width: 40%;
    }

    &-4 {
      width: 20%;
    }
  }

  &.browser0 {
    .ss-item {
      background-image: linear-gradient(90deg,
          rgba(0, 0, 0, 0) 0%,
          rgba(217, 217, 217, 0.8) 50.5%,
          rgba(0, 0, 0, 0) 100%);
    }
  }
  &.browser {
    .ss-item {
      background-image: linear-gradient(90deg,
          rgba(199, 217, 255, 0) 0%,
          rgba(199, 217, 255, 0.8) 50.5%,
          rgba(199, 217, 255, 0) 100%);
    }
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0 50%;
    }
  }
}
</style>
